define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../entity/SmaCondition", "../../utils/MathUtil", "../domain", "../services", "../services/EventManager"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, SmaCondition_1, MathUtil_1, domain_1, services_1, EventManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sma = void 0;
    class Sma extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "RefId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Lga", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaCode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaCodeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CategoryGroup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CategoryGroupError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Category", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CategoryError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Area", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AreaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Description", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DescriptionError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsSensitive", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsSensitiveError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SystemState", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SystemStateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Shape", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SmaCondition", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedSmaCondition", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SmaConditionError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, Sma.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.SmaCondition = [];
        }
        onRead(entity, parent) {
            this.SmaCondition = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.RefId = b.RefId;
            a.Lga = b.Lga;
            a.LgaCode = b.LgaCode;
            a.CategoryGroup = b.CategoryGroup;
            a.Category = b.Category;
            a.Area = (0, EntityUtil_1.toFloat)(entity.Area);
            a.Description = b.Description;
            a.IsSensitive = (0, EntityUtil_1.toInt)(entity.IsSensitive);
            a.SystemState = (0, EntityUtil_1.toInt)(entity.SystemState);
            a.AuditCreateUser = b.AuditCreateUser;
            a.AuditCreateDate = b.AuditCreateDate;
            a.AuditEditUser = b.AuditEditUser;
            a.AuditEditDate = b.AuditEditDate;
            a.SmaCondition = this.mergeArray(a.SmaCondition, b.SmaCondition, SmaCondition_1.SmaCondition);
            a.SelectedSmaCondition = a.SelectedSmaCondition && a.SmaCondition.find(x => x.Id == a.SelectedSmaCondition.Id) ? a.SelectedSmaCondition : null;
            a.Shape = (0, EntityUtil_1.mergePolygon)(a.Shape, b.Shape);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, Sma.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqString(validationState, "RefId", "Reference Id");
                this.validateReqString(validationState, "LgaCode", "LGA Code");
                this.validateReqNumber(validationState, "SystemState", "System State");
                this.validateReqString(validationState, "AuditCreateUser", "AUDIT_CREATE_USER");
                this.validateReqDate(validationState, "AuditCreateDate", "AUDIT_CREATE_DATE");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.SmaCondition) {
                for (let x of this.SmaCondition) {
                    x.walk(func, { leading });
                }
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                RefId: this.RefId,
                Lga: this.Lga,
                LgaCode: this.LgaCode,
                CategoryGroup: this.CategoryGroup,
                Category: this.Category,
                Area: this.Area,
                Description: this.Description,
                IsSensitive: this.IsSensitive,
                SystemState: this.SystemState,
                AuditCreateUser: this.AuditCreateUser,
                AuditCreateDate: this.AuditCreateDate,
                AuditEditUser: this.AuditEditUser,
                AuditEditDate: this.AuditEditDate,
                SmaCondition: this.SmaCondition.map(x => x.toJson()),
                Shape: this.Shape.toJSON(),
                IsGeometryModified: this.IsGeometryModified,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        get IsUserPriviledgedToEdit() {
            return this.SecurityAccessLevel == EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        get IsReadOnly() {
            return !this.IsUserPriviledgedToEdit || this.SystemState == domain_1.EntitySysStatusDomain.Archived;
        }
        get IsActive() {
            return this.SystemState == domain_1.EntitySysStatusDomain.Active;
        }
        get Categories() {
            let categories = [];
            let processedCategories = {};
            for (let cat of services_1.AppConfigManager.InstanceSync.SmaCategoryReferenceData) {
                if (!processedCategories.hasOwnProperty(cat.CategoryGroup)) {
                    processedCategories[cat.CategoryGroup] = true;
                    categories.push(cat.CategoryGroup);
                }
            }
            return categories;
        }
        get SubCategories() {
            if (this.Categories && this.Categories.length > 0) {
                let cat = this.CategoryGroup || this.Categories[0];
                return services_1.AppConfigManager.InstanceSync.getSmaSubCategoriesBySmaCategoryGroup(cat);
            }
            return [];
        }
        updateSmaOnGeometryChange() {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Updating Special Management Area");
                services_1.SrmsServiceManager.Instance.Sma.updateSmaOnGeometryChange(this.toJson()).then(res => {
                    if (res) {
                        if (res.GeometryAreaHec != -1) {
                            this.Area = (0, MathUtil_1.round)(res.GeometryAreaHec, 2);
                        }
                        if (res.Lga != null && res.LgaCode != null) {
                            this.Lga = res.Lga;
                            this.LgaCode = res.LgaCode;
                        }
                    }
                    resolve();
                }).catch(err => {
                    reject(err);
                });
            });
        }
        createNewSmaCondition(condition, permitType) {
            let smaCondition = new SmaCondition_1.SmaCondition(null, this);
            smaCondition.Condition = condition;
            smaCondition.PermitType = permitType;
            this.SmaCondition.push(smaCondition);
            return smaCondition;
        }
    }
    exports.Sma = Sma;
    Object.defineProperty(Sma, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Sma"
    });
    Object.defineProperty(Sma, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Special Management Area"
    });
    Object.defineProperty(Sma, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "RefId", "Lga", "LgaCode", "CategoryGroup", "Category", "Area", "Description", "IsSensitive", "SystemState", "AuditCreateUser", "AuditCreateDate", "AuditEditUser", "AuditEditDate", "Shape"]
    });
    Object.defineProperty(Sma, "RefIdLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Sma, "RefIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Sma, "LgaLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Sma, "LgaReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Sma, "LgaCodeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 10
    });
    Object.defineProperty(Sma, "LgaCodeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Sma, "CategoryGroupLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Sma, "CategoryGroupTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What is the primary type of Special Management Area?"
    });
    Object.defineProperty(Sma, "CategoryGroupReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Sma, "CategoryLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Sma, "CategoryTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What is the secondary type of Special Management Area?"
    });
    Object.defineProperty(Sma, "CategoryReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Sma, "AreaReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Sma, "DescriptionLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Sma, "DescriptionTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter a free-text description of the Special Management Area"
    });
    Object.defineProperty(Sma, "DescriptionReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Sma, "IsSensitiveTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Is the location and description of this Special Management Area culturally sensitive?"
    });
    Object.defineProperty(Sma, "IsSensitiveReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Sma, "SystemStateDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Sma, "SystemStateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Sma, "AuditCreateUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Sma, "AuditCreateUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Sma, "AuditCreateDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Sma, "AuditEditUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Sma, "AuditEditUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Sma, "AuditEditDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "RefId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "RefIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "Lga", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "LgaError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "LgaCode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "LgaCodeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "CategoryGroup", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "CategoryGroupError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "Category", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "CategoryError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "Area", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "AreaError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "Description", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "DescriptionError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "IsSensitive", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "IsSensitiveError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "SystemState", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "SystemStateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "AuditCreateUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "AuditCreateUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "AuditCreateDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "AuditCreateDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "AuditEditUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "AuditEditUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "AuditEditDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "AuditEditDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "Shape", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "SmaCondition", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "SelectedSmaCondition", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Sma.prototype, "SmaConditionError", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], Sma.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Sma.prototype, "IsUserPriviledgedToEdit", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Sma.prototype, "IsReadOnly", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Sma.prototype, "IsActive", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Sma.prototype, "Categories", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Sma.prototype, "SubCategories", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Sma.prototype, "updateSmaOnGeometryChange", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Sma.prototype, "createNewSmaCondition", null);
});
